import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Chip, Input, Modal } from "../../components/ui";
import { DataTable, when } from "../../components/admin/fields";
import useCursorList from "../../components/admin/useCursorList";
import { statusLabel } from "../../components/character/Card";
import { useToast } from "../../context/ToastContext";
import content from "../../services/api-content";
import "../../styles/content.css";

const FILTERS = [["", "ทั้งหมด"], ["pending", "รออนุมัติ"], ["approved", "เผยแพร่"], ["hidden", "ซ่อน"], ["rejected", "ไม่ผ่าน"], ["draft", "ร่าง"]];
const TONE = { approved: "pill--ok", pending: "pill--warn", hidden: "pill--bad", rejected: "pill--bad" };

export default function AdminCharacters() {
  const toast = useToast();
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [term, setTerm] = useState("");
  const [ask, setAsk] = useState(null); // { c, decision }
  const [reason, setReason] = useState("");
  const list = useCursorList((cursor) => content.admin.characters.list({ ...(status ? { status } : {}), q: term, cursor }), [status, term]);

  const act = async (c, decision, why) => {
    try {
      const r = await content.admin.characters.review(c.id, decision, why);
      toast("ดำเนินการแล้ว", "success");
      list.patch(c.id, (x) => ({ ...x, ...(r.character || {}) }));
      setAsk(null); setReason("");
    } catch (e) { toast(e.message, "error"); }
  };
  const cols = [
    { key: "name", label: "ตัวละคร", render: (c) => <Link to={`/c/${c.id}`}><b>{c.name}</b></Link> },
    { key: "creatorName", label: "ผู้สร้าง" },
    { key: "status", label: "สถานะ", render: (c) => <span className={`pill ${TONE[c.status] || ""}`}>{statusLabel(c.status)}</span> },
    { key: "isFeatured", label: "แนะนำ", render: (c) => (c.isFeatured ? "⭐" : "-") },
    { key: "createdAt", label: "สร้างเมื่อ", render: (c) => when(c.createdAt) },
    { key: "act", label: "", render: (c) => (
      <div className="row wrap" style={{ gap: 6 }}>
        {c.status !== "approved" ? <Button size="sm" variant="primary" onClick={() => act(c, "approve")}>อนุมัติ</Button> : null}
        {c.status === "pending" ? <Button size="sm" variant="danger" onClick={() => setAsk({ c, decision: "reject" })}>ไม่ผ่าน</Button> : null}
        {c.status === "approved" ? <Button size="sm" variant="danger" onClick={() => setAsk({ c, decision: "hide" })}>ซ่อน</Button> : null}
        <Button size="sm" onClick={() => act(c, c.isFeatured ? "unfeature" : "feature")}>{c.isFeatured ? "เลิกแนะนำ" : "แนะนำ"}</Button>
      </div>
    ) },
  ];
  return (
    <div>
      <div className="chip-row mb-16">{FILTERS.map(([v, l]) => <Chip key={v} active={status === v} onClick={() => setStatus(v)}>{l}</Chip>)}</div>
      <form className="row mb-16" onSubmit={(e) => { e.preventDefault(); setTerm(q.trim()); }}>
        <div className="grow"><Input type="search" aria-label="ค้นหาตัวละคร" placeholder="ค้นหาชื่อตัวละคร / ผู้สร้าง" value={q} onChange={(e) => setQ(e.target.value)} style={{ marginBottom: 0 }} /></div><Button type="submit">ค้นหา</Button>
      </form>
      <DataTable columns={cols} rows={list.items} loading={list.loading} error={list.error} onRetry={list.reload} hasMore={!!list.next} onMore={list.loadMore} moreLoading={list.more} empty="ไม่มีตัวละครในสถานะนี้" />
      <Modal open={!!ask} onClose={() => setAsk(null)} title={ask?.decision === "reject" ? "ไม่อนุมัติตัวละคร" : "ซ่อนตัวละคร"} footer={<><Button variant="ghost" onClick={() => setAsk(null)}>ยกเลิก</Button><Button variant="danger" onClick={() => act(ask.c, ask.decision, reason.trim())}>ยืนยัน</Button></>}>
        <p className="mb-8"><b>{ask?.c?.name}</b></p>
        <Input multiline label="เหตุผล (แจ้งเจ้าของ)" value={reason} onChange={(e) => setReason(e.target.value)} />
      </Modal>
    </div>
  );
}
